import React, {PureComponent} from 'react';
import {ProgressBar} from 'react-bootstrap';

class LoadingProgressBar extends PureComponent {
    render() {
        const {
            loading,
            percent,
            ...props
        } = this.props;

        let progressBar = (<div/>);
        let now = percent;
        if (typeof(now) === 'undefined') {
            now = 100;
        }

        if (loading) {
            progressBar = (<ProgressBar active now={now} />);
        }

        return progressBar;
    }
}

export default LoadingProgressBar;
